import DataType from '@opsbase/lib-datatype/DataType';
import i18n from '@opsbase/lib-i18n';
import Palette from '@opsbase/lib-palette';
import useAssetUpdate from '@opsbase/react-gql-hooks/asset/useAssetUpdate';
import ValueChooser from '@opsbase/web-data-choosers/ValueChooser/ValueChooser';
import useSelection from '@opsbase/web-data-selection/useSelection';
import useSelectionActions from '@opsbase/web-data-selection/useSelectionActions';
import { Dialog } from '@opsbase/web-dialogs/Dialog';
import DialogSize from '@opsbase/web-dialogs/Dialog/DialogSize';
import Card from '@opsbase/web-layout/Card/Card';
import Pane from '@opsbase/web-layout/Pane/Pane';
import Vertical from '@opsbase/web-layout/Vertical/Vertical';
import useNav from '@opsbase/web-nav/useNav/useNav';
import useParams from '@opsbase/web-nav/useParams';
import useNotificationActions from '@opsbase/web-notification/useNotificationActions';
import AssetTypePicker from '@opsbase/web-pickers/AssetTypePicker/AssetTypePicker';
import DatePicker from '@opsbase/web-pickers/DatePicker/DatePicker';
import Button from '@opsbase/web-ui/Button/Button';
import { Checkbox } from '@opsbase/web-ui/Checkbox';
import React, { useCallback, useMemo, useState } from 'react';
import WhereSettingsSection from '../opdefinition/settingssections/WhereSettingsSection';
function AssetMultiEditDialog() {
    var _a;
    const { id } = useParams();
    const dataType = DataType.ASSET;
    const { selecteds } = useSelection(dataType);
    const { clearSelection } = useSelectionActions(dataType);
    const { raise } = useNotificationActions();
    const updateAsset = useAssetUpdate();
    const [changeAssetType, setChangeAssetType] = useState(false);
    const [changeWhere, setChangeWhere] = useState(false);
    const [changeLastServiceDate, setChangeLastServiceDate] = useState(false);
    const [changeManufacturer, setChangeManufacturer] = useState(false);
    const [busy, setBusy] = useState(false);
    const ids = useMemo(() => (id === 'selected' ? selecteds.map(o => o.id) : [id]), [id, selecteds]);
    const { goBack } = useNav();
    const [patch, setPatch] = useState({});
    const manuValue = useMemo(() => (!!(patch === null || patch === void 0 ? void 0 : patch.manufacturer) ? [patch === null || patch === void 0 ? void 0 : patch.manufacturer] : []), [patch]);
    const handleAction = useCallback(async () => {
        var _a;
        if ((_a = patch === null || patch === void 0 ? void 0 : patch.places) === null || _a === void 0 ? void 0 : _a.length) {
            patch.places = patch.places.map(p => ({ id: p.id }));
        }
        setBusy(true);
        return raise(Promise.all(ids.map(theId => updateAsset({ id: theId, patch }))).finally(() => {
            clearSelection();
            setBusy(false);
            goBack();
        }), i18n.t('asset-edit-successful'));
    }, [patch, raise, ids, updateAsset, clearSelection, goBack]);
    const handleClose = useCallback(() => goBack(), [goBack]);
    const handleFieldUpdate = useCallback(field => value => {
        setPatch({ ...patch, [field]: value });
    }, [patch]);
    const handleChange = useCallback(update => {
        setPatch({ ...patch, ...update });
    }, [patch]);
    const handleChangeManufacturer = useCallback(mans => {
        setPatch({ ...patch, manufacturer: !!(mans === null || mans === void 0 ? void 0 : mans.length) ? mans[0] : null });
    }, [patch]);
    const handleAddManufacturer = useCallback(v => v, []);
    return (React.createElement(Dialog, { size: DialogSize.X800_Y550, title: i18n.t('edit-selected-assets'), padded: false, buttonsLeft: React.createElement(Button, { onClick: handleClose, color: Palette.Grey, disabled: busy, tabIndex: 1, label: i18n.t('cancel') }), buttonsRight: React.createElement(Button, { onClick: handleAction, disabled: busy, tabIndex: 0, label: i18n.t('make-updates') }), scroll: true },
        React.createElement(Pane, { paddingX: true },
            React.createElement(Vertical, { gutter: true },
                React.createElement(Checkbox, { label: i18n.t('change-asset-type'), color: Palette.GoodOldBlue, checked: changeAssetType, onChange: setChangeAssetType }),
                changeAssetType && (React.createElement(Pane, { paddingX: 16 },
                    React.createElement(AssetTypePicker, { white: true, fullWidth: true, value: (_a = patch === null || patch === void 0 ? void 0 : patch.assetType) === null || _a === void 0 ? void 0 : _a.toString(), onChange: handleFieldUpdate('assetType') }))),
                React.createElement(Checkbox, { label: i18n.t('change-last-service-date'), color: Palette.GoodOldBlue, checked: changeLastServiceDate, onChange: setChangeLastServiceDate }),
                changeLastServiceDate && (React.createElement(Pane, { paddingX: 16 },
                    React.createElement(DatePicker, { white: true, fullWidth: true, label: i18n.t('last-service'), value: patch === null || patch === void 0 ? void 0 : patch.lastServiceDate, onChange: handleFieldUpdate('lastServiceDate') }))),
                React.createElement(Checkbox, { label: i18n.t('change-asset-where'), color: Palette.GoodOldBlue, checked: changeWhere, onChange: setChangeWhere }),
                changeWhere && (React.createElement(Pane, { paddingX: 16 },
                    React.createElement(Card, { padding: true },
                        React.createElement(Vertical, { paddingY: true, gutter: true },
                            React.createElement(WhereSettingsSection, { definition: patch, isAsset: true, onChange: handleChange, isEditable: true }))))),
                React.createElement(Checkbox, { label: i18n.t('change-manufacturer'), color: Palette.GoodOldBlue, checked: changeManufacturer, onChange: setChangeManufacturer }),
                changeManufacturer && (React.createElement(Pane, { paddingX: 16 },
                    React.createElement(ValueChooser, { type: DataType.ASSET, fieldName: "manufacturer", value: manuValue, label: i18n.t('Select new manufacturer'), onChange: handleChangeManufacturer, onAddNew: handleAddManufacturer })))))));
}
export default AssetMultiEditDialog;
